import { inject, Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '@agilox/ui-common';
import { TranslateService } from '@ngx-translate/core';
import { FailureCategoryKey } from '../services/failure-order-workflow/failure-category.enum';
import { FailureIconType } from '../../enums/failure-icon-type.enum';

@Pipe({
	name: 'failureCategorySelectOptions',
})
export class FailureCategorySelectOptionsPipe implements PipeTransform {
	private translate: TranslateService = inject(TranslateService);

	transform(categories: string[]): SelectOption<string>[] {
		if (!categories) {
			return [];
		}
		return categories.map((category: FailureCategoryKey) => ({
			value: category.toLowerCase(),
			title: this.translate.instant(`failures.${category.toLowerCase()}s`),
			icon: FailureIconType[category],
		}));
	}
}
